import { createRouteFor } from "@components-common/routes";
import { dataSection, dataSectionBase} from "../routes.section";
const basePath = dataSectionBase;

const routesForMaterial = createRouteFor<typeof dataSection,"materials">(dataSection,"materials");

export const materialsRoutes = {
  index: routesForMaterial("index",{basePath}),
  create: routesForMaterial("create",{basePath}),
  details: routesForMaterial("details",{basePath})
}

export type MaterialsRoutesIds = typeof materialsRoutes[keyof typeof materialsRoutes]["id"];
